import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import Box from '@material-ui/core/Box';
import { isIE } from 'utils/stringUtils';
import { useSelector } from 'react-redux';
import { makeSelectAllowSignIn } from 'containers/Main/selectors';
import useSiteCopySelector from 'components/useSiteCopySelector';
import Hidden from '@material-ui/core/Hidden';
import ShareWithDropdown from 'components/ShareWithDropdown';
import HeartEmptyIcon from './images/heart.svg';
import HeartFullIcon from './images/heart-full.svg';
import ActionButton from './ActionButton';
import AdminBtn from './AdminBtn';

const ActionButtons = ({ data: { resourceData, actionProps } }) => {
  const [resourceItemPageSiteCopy] = useSiteCopySelector([
    'resource-item-page',
  ]);
  const allowSignIn = useSelector(makeSelectAllowSignIn());
  const item = _get(resourceData, 'items.0', false);

  if (!item) return null;

  const {
    fields: { name, title },
    sys: { id },
  } = item;
  const { save, saved, isAdmin, ...linkProps } = actionProps;

  return (
    <>
      {isAdmin && (
        <Hidden xsDown>
          <AdminBtn id={id} {...linkProps} />
        </Hidden>
      )}
      <Box
        component="div"
        display="flex"
        justifyContent={isIE() ? 'space-around' : 'space-evenly'}
        flex="1 1 auto"
      >
        {allowSignIn && (
          <ActionButton
            icon={saved ? HeartFullIcon : HeartEmptyIcon}
            id="save-as-favorite"
            label={
              saved
                ? _get(resourceItemPageSiteCopy, 'pageCopy.removeFavoriteLabel')
                : _get(resourceItemPageSiteCopy, 'pageCopy.saveFavoriteLabel')
            }
            clickHandler={save}
            isBig
          />
        )}
        <ShareWithDropdown
          id={id}
          name={name || title}
          type="topic"
          iconOnly
          isButton
          isBig
        />
      </Box>
    </>
  );
};

ActionButtons.propTypes = {
  data: PropTypes.object,
};

export default ActionButtons;
